'use client';
var styles = {"article":"ToastWrapper-module_article__8bR1m","bottom-position-basic":"ToastWrapper-module_bottom-position-basic__kP67r","bottom-position-button":"ToastWrapper-module_bottom-position-button__WVFql","slide":"ToastWrapper-module_slide__JNUXG","ani-active":"ToastWrapper-module_ani-active__ArmuE","fade":"ToastWrapper-module_fade__UVLHm"};

export { styles as default };
